<template>
  <div>
    <h2 v-translate>Terms and Conditions</h2>
    <p> Terms and Conditions</p>
  </div>
</template>

<script>
export default {
  name: 'TermsAndConditions'
}
</script>

<style lang="scss" scoped>

</style>
